import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-formation',
  templateUrl: './formation.component.html',
  styleUrls: ['./formation.component.scss']
})
export class FormationComponent implements OnInit {
  pdfSrc = '/assets/pdf/iqac/IQAC Formation final 2021.pdf'


  constructor() { }

  ngOnInit(): void {
  }

}
